import {
    FaLinkedinIn,
    FaGithub,
    FaFacebook,
    FaSpotify,
    FaTwitter,
} from "react-icons/fa";

const ContactData = {
    contact_content_head: "Let's get in touch",
    contact_content_desc:
        "I enjoy discussing new projects and design challenges. Please share as much info, as possible so we can get the most out of our first catch-up.",

    contact_content_place: "DVC Colony, Purulia, WB.",
    contact_content_phone: "(+91) 77975 73916",

    contact_form_head: "Estimate your Project?",

    contact_form_input_1: "What's Your Name:",
    contact_form_input_2: "Your Email Address:",
    contact_form_input_3: "How can I Help you?",

    contact_icon_linkedin: <FaLinkedinIn />,
    contact_icon_github: <FaGithub />,
    contact_icon_facebook: <FaFacebook />,
    contact_icon_spotify: <FaSpotify />,
    contact_icon_twitter: <FaTwitter />,

    contact_link_linkedin: "",
    contact_link_github: "",
    contact_link_facebook: "",
    contact_link_spotify: "",
    contact_link_twitter: "",
};

export default ContactData;
